import * as React from "react"
import type { SVGProps } from "react"
const SvgOnePerson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 12.14q-1.65 0-2.82-1.17Q8 9.79 8 8.14c0-1.65.4-2.04 1.18-2.82Q10.35 4.14 12 4.14c1.65 0 2.04.4 2.83 1.18Q16 6.49 16 8.14c0 1.65-.4 2.04-1.17 2.83A4 4 0 0 1 12 12.14m-8 6v-.8q0-.84.44-1.56.44-.71 1.16-1.09a15 15 0 0 1 3.15-1.16 14 14 0 0 1 3.25-.39 14 14 0 0 1 6.4 1.55q.72.38 1.16 1.09.45.72.44 1.56v.8q0 .82-.59 1.42a2 2 0 0 1-1.41.58H6q-.82 0-1.41-.58A2 2 0 0 1 4 18.13m2 0h12v-.8a1 1 0 0 0-.5-.85q-1.34-.67-2.72-1.01a11.6 11.6 0 0 0-5.55 0q-1.38.33-2.73 1.01a1 1 0 0 0-.5.85zm6-8q.83 0 1.41-.58.6-.6.59-1.42 0-.82-.59-1.41A2 2 0 0 0 12 6.14q-.83 0-1.41.59A2 2 0 0 0 10 8.14q0 .82.59 1.42.58.58 1.41.58" />
  </svg>
)
export default SvgOnePerson
